module.exports = __webpack_public_path__ + "img/McD_Unternehmen_Fullscreenimages_01.2979df21.jpg";